/**
 * Indicates whether smooth scrolling should be enabled.
 * 
 * @returns {boolean} true if lenis should be enabled on current page.
 */
export function isLenisActive() {
    const stoppedLenisPaths = [
        '/lp/load-testing-services/',
        '/lp/performance-testing-services/',
        '/lp/stress-testing-services/'
    ];
    const pathname = (self.location.pathname ?? '').toLowerCase();

    return stoppedLenisPaths.indexOf(pathname) === -1;
}
